import Vue from "vue";
import VueRouter from "vue-router";
import EventBus from "@/eventbus";
import { NAVIGATE_COMPANY_PAGE } from "@/event";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../components/Home"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../components/ContactUs"),
  },
  {
    path: "/career",
    name: "career",
    component: () => import("../components/Career/CareerFinder"),
  },
  {
    path: "/career/:id",
    name: "career-detail",
    component: () => import("../components/Career/CareerDetail"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../components/Login/Login"),
  },
  {
    path: "/register/:mode?/:email?/:authToken?",
    name: "register",
    component: () => import("../components/Login/Register"),
  },
  {
    path: "/videoLog",
    name: "videoLog",
    component: () =>
      import("../components/VideoPlayerLibrary/VideoPlayerLib.vue"),
  },
  {
    path: "/assessment/landing-page",
    name: "assessment-landing-page",
    component: () => import("../components/Assessment/LandingPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assessment/questionnaire",
    name: "assessment-questionnaire",
    component: () => import("../components/Assessment/Questionnaire.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assessment/results-page",
    name: "assessment-results-page",
    component: () => import("../components/Assessment/ResultsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/assessment/cluster-chosen",
    name: "assessment-cluster-chosen",
    component: () => import("../components/Assessment/ClusterChosen.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mentor/profile",
    name: "mentor-profile",
    component: () => import("../components/Mentor/MentorProfile"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mentor/edit/profile",
    name: "mentor-profile-edit",
    component: () => import("../components/Mentor/MentorProfile"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mentor/profile/:id",
    name: "mentor-profile-id",
    component: () => import("../components/Mentor/MentorProfile"),
  },
  {
    path: "/mentors",
    name: "mentors",
    component: () => import("../components/Mentor/Mentors"),
  },
  {
    path: "/mentee/edit/profile",
    name: "mentee-profile-edit",
    component: () => import("../components/Settings/Settings"),
    meta: { requiresAuth: true },
  },
  {
    path: "/company/:id",
    name: "company-id",
    component: () => import("../components/Company/CompanyProfile"),
  },
  {
    path: "/companies",
    name: "companies",
    component: () => import("../components/Company/Companies"),
  },
  {
    path: "/super-admin/dashboard",
    name: "super-admin-dashboard",
    component: () => import("../components/SuperAdmin/Dashboard"),
    meta: { requiresAuth: true },
  },
  {
    path: "/super-admin/subscriptions",
    name: "super-admin-subscriptions",
    component: () => import("../components/SuperAdmin/Subscriptions"),
    meta: { requiresAuth: true },
  },
  {
    path: "/super-admin/web-content",
    name: "super-admin-web-content",
    component: () => import("../components/SuperAdmin/WebContent"),
    meta: { requiresAuth: true },
  },
  {
    path: "/super-admin/advertisements",
    name: "super-admin-advertisements",
    component: () => import("../components/SuperAdmin/Advertisements"),
    meta: { requiresAuth: true },
  },
  {
    path: "/company-admin/invite-mentors",
    name: "company-admin-invite-mentors",
    component: () => import("../components/CompanyAdmin/InviteMentors"),
    meta: { requiresAuth: true },
  },
  {
    path: "/sessions/",
    name: "sessions",
    component: () => import("../components/Sessions/Sessions"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/",
    name: "settings",
    component: () => import("../components/Settings/Settings"),
    meta: { requiresAuth: true },
  },
  {
    path: "/landing/",
    name: "landing",
    component: () => import("../components/Landing/Landing"),
  },
  {
    path: "/about/",
    name: "about",
    component: () => import("../components/Landing/About"),
  },
  {
    path: "/mentee/calendar",
    name: "mentee-calendar",
    component: () => import("../components/Calendar/MenteeCalendar"),
    meta: { requiresAuth: true },
  },
  {
    path: "/mentor/calendar",
    name: "mentor-calendar",
    component: () => import("../components/Calendar/MentorCalendar"),
    meta: { requiresAuth: true },
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const menteeJwt = localStorage.getItem("mentee-jwt");
  const mentorJwt = localStorage.getItem("mentor-jwt");
  const companyAdminJwt = localStorage.getItem("company-admin-jwt");
  const superAdminJwt = localStorage.getItem("super-admin-jwt");

  const loggedIn = menteeJwt || mentorJwt || companyAdminJwt || superAdminJwt;

  // Redirect to Home if trying to access login, register, or landing when already logged in
  if (
    loggedIn &&
    (to.name === "login" || to.name === "register" || to.name === "landing")
  ) {
    next({ name: "home" });
    return;
  }

  // Redirect to login if route requires auth
  if (!loggedIn && to.matched.some((record) => record.meta.requiresAuth)) {
    next({ name: "login" });
    return;
  }

  // Redirect to Landing if not logged in and accessing Home
  if (
    !loggedIn &&
    (to.name === "home" || to.name === "super-admin-dashboard")
  ) {
    next({ name: "landing" });
    return;
  }

  if (companyAdminJwt && to.name === "home") {
    EventBus.$emit(NAVIGATE_COMPANY_PAGE);
    return;
  }

  if (superAdminJwt && to.name === "home") {
    next({ name: "super-admin-dashboard" });
    return;
  }

  next();
});

export default router;
